import React from 'react';
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  makeStyles
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';

const useClasses = makeStyles(theme => ({
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textAlign: 'center'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(4)
  },
  message: {
    color: theme.palette.secondary.main
  }
}));

const LoadingModal = function LoadingModal(): React.ReactElement {
  const classes = useClasses();
  const isLoading = useSelector((state: iRootState) => state.loading.isLoading);

  return (
    <Dialog
      open={isLoading}
      maxWidth='xs'
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
    >
      {/* <DialogTitle disableTypography className={classes.title}>
        <Typography variant='h6'>Please wait</Typography>
      </DialogTitle> */}
      <DialogContent className={classes.content}>
        <CircularProgress color='primary' />
        <Typography variant='body2' className={classes.message}>
          Please wait...
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal;
